export default __webpack_public_path__ + "static/media/Image41.20891da9.png";